// extracted by mini-css-extract-plugin
export var cartContainer = "_py-4";
export var gray = "_py-1";
export var itemContainer = "_py-2";
export var itemDetails = "_py-3";
export var strong = "_py-0";